import { Box, BoxProps } from 'src/components/ui';
import React, { FC } from 'react';

interface ICustomContainer extends BoxProps {
	children: React.ReactNode;
}

const CustomContainer: FC<ICustomContainer> = ({ children, ...props }) => {
	return (
		<Box
			bg="white"
			maxW="1500px"
			p={{ base: '12px', md: '25px' }}
			borderRadius={{ base: '4px', md: '8px' }}
			boxShadow={{ base: 'none', md: '0 0px 15px -3px rgba(0, 0, 0, 0.1)' }}
			position="relative"
			zIndex={0}
			minW={{ base: '100%', md: '75%' }}
			w={{ base: '100%', md: 'auto' }}
			h="fit-content"
			{...props}
		>
			{children}
		</Box>
	);
};

export default CustomContainer;
